<div class="main_body">
  <div class="contents contents--privacy">
    <h2 class="contents__title" i18n="@@pages.privacyPolicy.title.main">プライバシーポリシー</h2>
    <h5 i18n="@@pages.privacyPolicy.message.introduction">
        以下のプライバシーポリシーをよくお読みいただき、同意の上でご利用ください。当社が提供するGOKURIサービスを用いて計測・分析を行う病院・介護施設の職員等のスタッフの方にはGOKURIサービススタッフプライバシーポリシーが適用され、GOKURIサービスを用いて計測・分析を受けるご高齢の方、ご患者様等のユーザーにはユーザープライバシーポリシーが適用され、スタッフはユーザーに対して本プライバシーポリシーに同意を得るものとします。
    </h5>

  <div class="legal-page">

  <mat-card appearance="outlined">

    <mat-tab-group animationDuration="0ms" [selectedIndex]="selectedTabIndex">
      <mat-tab label=" GOKURIサービスユーザープライバシーポリシー">
        <h2>GOKURIサービスユーザープライバシーポリシー</h2>
        <p>
          PLIMES株式会社（以下「当社」といいます。）は、個人情報保護に関する法令及びその他の規範を遵守するとともに、当社が提供するGOKURIサービス（以下「本サービス」といいます。）を用いて計測・分析を受けるご高齢の方、ご患者様等のユーザー（以下「ユーザー」といいます。）の個人情報を適切に取り扱うため、以下のとおりプライバシーポリシー（以下「当プライバシーポリシー」といいます。）を定め、ユーザーが安心してご利用頂けるよう取り組んでおります。なお、当プライバシーポリシーにおいて別段の定めがない限り、当プライバシーポリシーにおける用語の定義は、個人情報保護法の定めに従います。
        </p>

        <h2>1.個人情報の利用目的</h2>
        <p>
          当社は、ユーザーの当プライバシーポリシーへの同意に基づきユーザーの個人情報を本サービスの提供を行っている介護施設等の施設又は外部の専門家から取得し、取得したユーザーの個人情報を、以下の目的で利用いたします。当社が取得するユーザーの個人情報としては、ユーザーの氏名、任意のID、位置情報、嚥下記録情報、食事の写真及び食事中の動画、嚥下音、体調に関する情報等が含まれることがあります。また、当社は、ユーザーの当プライバシーポリシーへの同意に基づき、健診結果等のユーザーに関する要配慮個人情報を取得する場合がございます。
        </p>
        <ol class="no-style-list">
          <li>① 本サービスを提供する目的</li>
          <li>② ユーザーに本サービス、新サービスその他の各種サービスに関するその他のお知らせ、連絡、ご案内をする目的</li>
          <li>③ ユーザーの本人確認を行う目的</li>
          <li>④ ユーザーからのお問い合わせに対応する目的</li>
          <li>⑤ 本サービスの利用状況・満足度等を調査・分析する目的</li>
          <li>⑥ 本サービスの内容をよりご満足いただけるよう改良・改善、又は新サービスを開発する目的</li>
          <li>⑦ ユーザーの個人情報を統計的に処理した情報を、集約し公表又は第三者に提供する目的</li>
          <li>⑧ 嚥下記録等のユーザーの個人情報を分析し、誤嚥性肺炎予防、オーラルフレイル予防等のユーザーの健康促進に資するサービスの実現を目的とするデータ・AIモデルの作成する目的</li>
          <li>⑨ ユーザーの個人情報を用いて、ユーザーの属性に応じた商品・サービスに関する広告等を配信する目的</li>
          <li>⑩ 調査のご協力依頼や各種イベントへのご参加をお願いしたり、その結果等をご報告したりする目的</li>
          <li>⑪ 本サービス運営上のトラブルの解決の目的</li>
          <li>⑫ 必要な許認可の取得、事故発生時・製品回収時等の報告その他、業務上必要な情報の収集及び連絡をする目的</li>
          <li>⑬ 外部専門家が嚥下記録等のユーザーの個人情報を分析・研究し、ユーザーへの助言の提供ために、ユーザーの個人情報を外部専門家に提供する目的</li>
          <li>⑭ 上記の各利用目的に付随する目的</li>
        </ol>

        <h2>2.個人データの第三者への提供</h2>
        <ol class="no-style-list">
          <li>(1) 当社は、以下の場合を除いて、あらかじめユーザーご本人の同意を得ることなく、ユーザーの個人データを第三者に提供いたしません。</li>
          <ol class="no-style-list">
            <li>① 法令に基づく場合
            <li>② 人の生命、身体又は財産の保護のために必要がある場合であって、本人の同意を得ることが困難であるとき</li>
            <li>③ 公衆衛生の向上又は児童の健全な育成の推進のために特に必要がある場合であって、本人の同意を得ることが困難であるとき</li>
            <li>④ 国の機関若しくは地方公共団体又はその委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合であって、本人の同意を得ることにより当該事務の遂行に支障を及ぼすおそれがあるとき
            </li>
            <li>
              ⑤当該第三者が学術研究機関等である場合であって、当該第三者が当該個人データを学術研究目的で取り扱う必要があるとき（当該個人データを取り扱う目的の一部が学術研究目的である場合を含み、個人の権利利益を不当に侵害するおそれがある場合を除く。）。
            </li>
            <li>⑥ 当社が利用目的の達成に必要な範囲内において個人情報の取扱いの全部又は一部を委託する場合</li>
            <li>⑦ 合併その他の事由による事業の承継に伴って個人情報が提供される場合</li>
            <li>
              ⑧個人情報を特定の者との間で共同して利用する場合であって、その旨並びに共同して利用される個人情報の項目、共同して利用する者の範囲、利用する者の利用目的及び当該個人情報の管理について責任を有する者の氏名又は名称及び住所並びに法人にあっては、その代表者の氏名について、予め本人に通知し、又は本人が容易に知り得る状態に置いている場合
            </li>
          </ol>
          <li>(2) 第１項にかかわらず、当社は、当プライバシーポリシーに同意いただいた場合、ユーザーの個人データを次のとおり第三者に提供する場合があります。</li>

          <ol class="no-style-list">
            <li>
              ①外部専門家が嚥下記録等のユーザーの個人情報を分析・研究し、ユーザーへ助言の提供ために、ユーザーの個人情報を外部専門家に提供する場合（当該助言等を本サービスの提供を行っている介護施設等の施設に提供する場合を含みます。）
            </li>
            <li>
              ②ユーザーの個人情報を用いて、ユーザーの属性に応じた商品・サービスに関する広告等を配信するために、当社の株主及びその子会社、広告配信事業者、データ分析事業者、業務委託先、業務提携先等の第三者に対して提供する場合
            </li>
          </ol>
        </ol>

        <h2>3.個人データの外国にある第三者への提供</h2>
        <p>当社は、次に掲げる場合を除き、当社が取り扱う個人情報を、あらかじめご本人様の同意を得ないで、外国にある第三者に提供いたしません。</p>
        <ol class="no-style-list">
          <li>① 前条1項1号から5号の法により例外が認められている場合</li>
          <li>② 個人の権利利益を保護する上で我が国と同等の水準にあると認められる個人情報の保護に関する制度を有している外国として規則で定める国にある第三者に提供する場合</li>
          <li>③ 個人情報の提供を受ける者との間で、当該提供を受ける者における当該個人情報の取扱いについて、適切かつ合理的な方法により、個人情報保護法第4章第1節の趣旨に沿った措置の実施が確保されている場合</li>
          <li>④ 個人情報の提供を受ける者が、個人情報の取扱いに係る国際的な枠組みに基づく認定を受けている場合</li>
        </ol>
        <p>なお、上記③④に該当する場合、当社は、第三者による相当措置の継続的実施を確保するために必要な措置を講じています。当該措置の詳細については、当プライバシーポリシー末尾に記載のお問合せ先までお問合せください。</p>

        <h2>4.個人情報の管理</h2>
        <p>
          当社は、収集した個人情報について、適切かつ厳重に管理し、個人情報の漏洩や紛失、改ざん等の防止に適切な対策を講じ、当社の従業員に対して必要かつ適切な監督を行い、また、当社が個人情報の取扱いの全部又は一部を委託する場合には、委託先において個人情報の安全管理が図られるよう必要かつ適切な監督を行うことでユーザーの個人情報保護に努めます。
          当社における個人情報の取得体制及び講じている措置の内容の詳細については、当プライバシーポリシー末尾に記載のお問合せ先までお問合せください。
          また、当社は、「1.個人情報の利用目的」記載の利用目的の達成に必要な範囲内において、個人情報を保存し、個人情報を利用する必要がなくなったときは、遅滞なく個人情報を消去します。</p>

        <h2>5.ユーザーの位置情報の取扱い</h2>
        <p>
          当社は、ユーザーの端末からGPS機能を用いて、クラッカーテストプロトコル実施中において、約10秒間隔で100メートル程度の精度の位置情報（GPS情報）を取得し、取得したGPS情報を、5キロメートル四方単位の位置情報へ変換するなどの加工を行った上で、当社が保有するユーザーの個人情報等と紐づけて、「1.個人情報の利用目的」記載の各種目的で蓄積し、利用しますが、第三者に提供することはありません。
        </p>

        <h2>6.個人情報に関する請求</h2>
        <p>
          ユーザーは、ユーザーの個人情報に関して、個人情報保護法の定めに基づき、開示・訂正・追加・削除・利用停止等、第三者への提供の停止、第三者提供記録の開示の請求を行うことができます。この場合、当社は、個人情報保護法の定めに従って適切に対応いたします。
        </p>

        <h2>7.プライバシーポリシーの変更及び通知</h2>
        <p>
          当社では、法令等の変更及び運営方針の変更等に伴い、当プライバシーポリシーの内容を事前の予告なく変更することがあります。ユーザーへの個別の通知は行っておりませんので、ご利用の際には当プライバシーポリシーの最新の内容をご参照ください。
        </p>

        <h2>8.個人情報に関するお問合せ先</h2>
        <p>個人情報に関する開示・訂正・削除・利用停止等・第三者への提供の停止・第三者提供記録の開示のご請求、ご不明な点についてのお問合せについては、下記経営企画室宛てにメールにてお問合せください。</p>

        <h2>【お問合せ先】</h2>
        <p>茨城県つくば市天王台1-1-1<br>
          PLIMES株式会社<br>
          privacy＠plimes.com<br></p>

        <p>PLIMES株式会社<br>
          2022年08月1日作成<br>
          2024年10月1日更新</p>



      </mat-tab>

      <mat-tab label="GOKURIサービススタッフプライバシーポリシー">

        <h2>GOKURIサービススタッフプライバシーポリシー</h2>


        <p>
          PLIMES株式会社（以下「当社」といいます。）は、個人情報保護に関する法令及びその他の規範を遵守するとともに、当社が提供するGOKURIサービスを用いて計測・分析を行う病院・介護施設の職員等のスタッフ（以下「スタッフ」といいます。）の個人情報を適切に取り扱うため、以下のとおりプライバシーポリシー（以下「当プライバシーポリシー」といいます。）を定め、スタッフが安心してご利用頂けるよう取り組んでおります。なお、当プライバシーポリシーにおいて別段の定めがない限り、当プライバシーポリシーにおける用語の定義は、個人情報保護法の定めに従います。
        </p>

        <h2>1.個人情報の利用目的</h2>
        <p>
          当社は、当社において取得し、管理するスタッフの個人情報を、以下の目的で利用いたします。当社が取得するスタッフの個人情報としては、スタッフの氏名、任意のID、位置情報、Emailアドレス、住所、ログインID等が含まれることがあります。
        <p></p>
        <ol class="no-style-list">
          <li>① 本サービスを提供する目的</li>
          <li>② スタッフに本サービス、新サービスその他の各種サービスに関する購入の確認やお届け、請求やお支払い、ご案内その他のお知らせや連絡をする目的</li>
          <li>③ スタッフの本人確認を行う目的</li>
          <li>④ 本サービスの利用状況・満足度等を調査・分析する目的</li>
          <li>⑤ 本サービスの内容をよりご満足いただけるよう改良・改善、又は新サービスを開発する目的</li>
          <li>⑥ スタッフの個人情報を統計的に処理した情報を、集約し調査結果として公表する目的</li>
          <li>⑦ スタッフの個人情報を含むサービスの利用状況等を統計的に処理した情報を、集約し第三者へ無償・有償を問わず提供する</li>
          <li>⑧ 調査のご協力依頼や各種イベントへのご参加をお願いしたり、その結果等をご報告したりする目的</li>
          <li>⑨ 本サービス運営上のトラブルの解決の目的</li>
          <li>⑩ 必要な許認可の取得、事故発生時・製品回収時等の報告その他、業務上必要な情報の収集及び連絡をする目的</li>
          <li>⑪ 上記の各利用目的に付随する目的</li>
        </ol>

        <h2>2.個人データの第三者への提供</h2>
        <p>当社は、以下の場合を除いて、あらかじめスタッフご本人の同意を得ることなく、スタッフの個人データを第三者に提供いたしません。</p>
        <ol class="no-style-list">

          <li>① 法令に基づく場合</li>
          <li>② 人の生命、身体又は財産の保護のために必要がある場合であって、本人の同意を得ることが困難であるとき</li>
          <li>③ 公衆衛生の向上又は児童の健全な育成の推進のために特に必要がある場合であって、本人の同意を得ることが困難であるとき</li>
          <li>④ 国の機関若しくは地方公共団体又はその委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合であって、本人の同意を得ることにより当該事務の遂行に支障を及ぼすおそれがあるとき</li>
          <li>⑤当該第三者が学術研究機関等である場合であって、当該第三者が当該個人データを学術研究目的で取り扱う必要があるとき（当該個人データを取り扱う目的の一部が学術研究目的である場合を含み、個人の権利利益を不当に侵害するおそれがある場合を除く。）。</li>
          <li>⑥ 当社が利用目的の達成に必要な範囲内において個人情報の取扱いの全部又は一部を委託する場合</li>
          <li>⑦ 合併その他の事由による事業の承継に伴って個人情報が提供される場合</li>
          <li>⑧個人情報を特定の者との間で共同して利用する場合であって、その旨並びに共同して利用される個人情報の項目、共同して利用する者の範囲、利用する者の利用目的及び当該個人情報の管理について責任を有する者の氏名又は名称及び住所並びに法人にあっては、その代表者の氏名について、予め本人に通知し、又は本人が容易に知り得る状態に置いている場合</li>
        </ol>

        <h2>3.個人データの外国にある第三者への提供</h2>
        <p>当社は、次に掲げる場合を除き、当社が取り扱う個人情報を、あらかじめご本人様の同意を得ないで、外国にある第三者に提供いたしません。</p>
        <ol class="no-style-list">
          <li>① 前条1項1号から5号の法により例外が認められている場合</li>
          <li>② 個人の権利利益を保護する上で我が国と同等の水準にあると認められる個人情報の保護に関する制度を有している外国として規則で定める国にある第三者に提供する場合</li>
          <li>③ 個人情報の提供を受ける者との間で、当該提供を受ける者における当該個人情報の取扱いについて、適切かつ合理的な方法により、個人情報保護法第4章第1節の趣旨に沿った措置の実施が確保されている場合</li>
          <li>④ 個人情報の提供を受ける者が、個人情報の取扱いに係る国際的な枠組みに基づく認定を受けている場合</li>
        </ol>
        なお、上記③④に該当する場合、当社は、第三者による相当措置の継続的実施を確保するために必要な措置を講じています。当該措置の詳細については、当プライバシーポリシー末尾に記載のお問合せ先までお問合せください。

        <h2>4.個人情報の管理</h2>
        <p>
          当社は、収集した個人情報について、適切かつ厳重に管理し、個人情報の漏洩や紛失、改ざん等の防止に適切な対策を講じ、当社の従業員に対して必要かつ適切な監督を行い、また、当社が個人情報の取扱いの全部又は一部を委託する場合には、委託先において個人情報の安全管理が図られるよう必要かつ適切な監督を行うことでスタッフの個人情報保護に努めます。
          当社における個人情報の取得体制及び講じている措置の内容の詳細については、当プライバシーポリシー末尾に記載のお問合せ先までお問合せください。
          また、当社は、「1.個人情報の利用目的」記載の利用目的の達成に必要な範囲内において、個人情報を保存し、個人情報を利用する必要がなくなったときは、遅滞なく個人情報を消去します。</p>

        <h2>5.スタッフの位置情報の取扱い</h2>
        <p>
          当社は、スタッフの端末からGPS機能を用いて、クラッカーテストプロトコル実施中において、約10秒間隔で100メートル程度の精度の位置情報（GPS情報）を取得し、取得したGPS情報を、5キロメートル四方単位の位置情報へ変換するなどの加工を行った上で、当社が保有するスタッフの個人情報等と紐づけて、「1.個人情報の利用目的」記載の各種目的で蓄積し、利用しますが、第三者に提供することはありません。
        </p>

        <h2>6.個人情報に関する請求</h2>
        <p>
          スタッフは、スタッフの個人情報に関して、個人情報保護法の定めに基づき、開示・訂正・追加・削除・利用停止等、第三者への提供の停止、第三者提供記録の開示の請求を行うことができます。この場合、当社は、個人情報保護法の定めに従って適切に対応いたします。
        </p>

        <h2>7.プライバシーポリシーの変更及び通知</h2>
        <p>
          当社では、法令等の変更及び運営方針の変更等に伴い、当プライバシーポリシーの内容を事前の予告なく変更することがあります。スタッフへの個別の通知は行っておりませんので、ご利用の際には当プライバシーポリシーの最新の内容をご参照ください。
        </p>

        <h2>8.個人情報に関するお問合せ先</h2>
        <p>個人情報に関する開示・訂正・削除・利用停止等・第三者への提供の停止・第三者提供記録の開示のご請求、ご不明な点についてのお問合せについては、下記経営企画室宛てにメールにてお問合せください。</p>

        <h2>【お問合せ先】</h2>
        <p>茨城県つくば市天王台1-1-1<br>
          PLIMES株式会社<br>
          privacy＠plimes.com<br></p>

        <p>PLIMES株式会社<br>
          2022年08月1日作成<br>
          2024年10月1日更新</p>


      </mat-tab>
    </mat-tab-group>

  </mat-card>
</div>
